import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import 'antd/dist/antd.min.css';
import 'antd/dist/antd.variable.min.css';
import './index.less';
import { AppLayout } from './AppLayout';
import { useSharedGlobalState } from './hooks';
import { LoginLayout } from './components';
import { systemIds } from './utils/systemIds';
import { useJfGlobalProjectStore } from '@core/rc-state';
export const App = (props) => {
    const { authLoginType = 'KXGC', mode, system } = props;
    const systemId = system ? systemIds[system] : null;
    // @ts-ignore
    const { setHeaders } = useJfGlobalProjectStore();
    const { _initStateByKey } = useSharedGlobalState();
    useEffect(() => {
        setHeaders({
            'system-id': '81529205975707745'
        });
        if (systemId) {
            _initStateByKey('systemId', systemId);
        }
    }, [systemId]);
    return (_jsx(LoginLayout, { authLoginType: authLoginType, mode: mode, children: _jsx(AppLayout, { ...props, systemId: systemId }) }));
};
